const sizes = {
  s: 'text-base2',
  l: 'text-lg',
};

interface Props {
  size?: keyof typeof sizes;
}

export function Chevron({ size = 's' }: Props) {
  return (
    <span className={`w-5 h-5 inline-flex items-center justify-center ${sizes[size]}`}>›</span>
  );
}
